import { Announcements } from '@app/core/async-services/http/versioned/interfaces';

export const ALL_EMPLOYEES = 'ALL_EMPLOYEES';
export type AllEmployees = typeof ALL_EMPLOYEES;

export type Recipient =
  | Announcements.Hotel
  | Announcements.Department
  | Announcements.Manager
  | AllEmployees;

export function isHotel(
  recipient: Recipient
): recipient is Announcements.Hotel {
  return typeof recipient === 'object' && 'entName' in recipient;
}

export function isDepartment(
  recipient: Recipient
): recipient is Announcements.Department {
  return typeof recipient === 'object' && 'departName' in recipient;
}

export function isManager(
  recipient: Recipient
): recipient is Announcements.Manager {
  return typeof recipient === 'object' && 'firstName' in recipient;
}

export function isAllEmployees(
  recipient: Recipient
): recipient is AllEmployees {
  return typeof recipient === 'string' && recipient === ALL_EMPLOYEES;
}
